import { Injectable } from '@angular/core'
import { Resolve } from '@angular/router'

import { OperadoraDeMaquina } from '../../pkw-data/collect/operadora-de-maquina.model'
import { OperadoraDeMaquinaService } from '../services/operadora-de-maquina.service'

@Injectable()
export class TodasOperadorasResolver implements Resolve<OperadoraDeMaquina[]> {
    constructor(private operadoraService: OperadoraDeMaquinaService) {}

    resolve() {
        return this.operadoraService.obterTodas()
    }
}



// WEBPACK FOOTER //
// ./src/app/core/resolvers/todas-operadoras.resolver.ts